import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
export const BasicHedgehogImage = () => <StaticImage width={300} src="../../images/lost-hog.png" />
